// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container.MuiContainer-root {
  display: grid;
}

.loading-spinner.MuiCircularProgress-root {
  margin: 10rem auto;
}
`, "",{"version":3,"sources":["webpack://./src/shared/Loader/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".loading-container.MuiContainer-root {\n  display: grid;\n}\n\n.loading-spinner.MuiCircularProgress-root {\n  margin: 10rem auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
